/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Delete_Folder_ConfirmInputs */

const en_dialog_delete_folder_confirm = /** @type {(inputs: Dialog_Delete_Folder_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Are you sure you want to delete this folder?`)
};

const es_dialog_delete_folder_confirm = /** @type {(inputs: Dialog_Delete_Folder_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Estás seguro de que quieres eliminar esta carpeta?`)
};

/**
* | output |
* | --- |
* | "Are you sure you want to delete this folder?" |
*
* @param {Dialog_Delete_Folder_ConfirmInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dialog_delete_folder_confirm = /** @type {((inputs?: Dialog_Delete_Folder_ConfirmInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Delete_Folder_ConfirmInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dialog_delete_folder_confirm(inputs)
	return en_dialog_delete_folder_confirm(inputs)
});